import Annotation from '@/components/Annotation';
import PageLayout from '@/components/PageLayout';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import PageConPc from '@/components/ProductDelta/delta2max';
import SEOlinksA from '@/components/SEOlinksA';
import PageConH5 from '@/componentsH5/ProductDelta/delta2max';
import { getDelta2MaxTimeLine, STAGES } from '@/constants/delta2max';
import getCanenterFlag from '@/utils/getCanEnterFlag';
import { useSupportData } from '@/utils/hooks';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import getHostApi from '@/utils/singUtil/getHostApi';
import { useGlobal } from '@/utils/useGlobal';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import EcoNavProduct from 'eco-design/sections/eco-nav-product';

// 产品详情页参数
const productName = 'delta-2-max-portable-power-station';
const generalKey = 'product_ps_delta_delta_2_max';
const WHITE_SITE = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn', 'au', 'za', 'tw', 'sa', 'br', 'mx', 'ph', 'nl'];
const theme = 'white';

export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useRouter, useState, useEffect, useRef, getSystemTime, useLang } = useGlobal();
    const router = useRouter();
    const { t } = useLang('delta2max');
    const { locale, query } = router;
    const PageCon = isMobile ? (locale === 'jp' ? PageConPc : PageConH5) : PageConPc;
    const [showTab, setShowTab] = useState('Overview');
    const [seoInfo, setSeoInfo] = useState({ title: t('seo_title'), desc: t('seo_desc') });
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);
    const { flag1, flag2, flag3 } = getCanenterFlag(router?.query?.cid); // 提前打开4-26号
    const TIME_LINE = getDelta2MaxTimeLine(locale, flag3 || flag1 || flag2);
    // 倒计时三个时间段
    const teaserTimeStamp: number = new Date(TIME_LINE?.teaser || 0).getTime(); // 预热开始时间
    const crowdfundingTimeStamp: number = new Date(TIME_LINE?.crowdfunding || 0).getTime(); // 早鸟众筹开始时间
    const crowdfundingTimeStamp2: number = new Date(TIME_LINE?.crowdfunding_stage2 || 0).getTime(); // 早鸟众筹第二阶段开始时间
    const detailTimeStamp: number = new Date(TIME_LINE?.detail || 0).getTime(); // 详情开始时间

    const dataA = {
        theme: 'white',
        tabItems: [
            {
                value: 'Overview',
                label: '概要',
            },
            {
                value: 'Specs',
                label: '仕様',
            },
            {
                value: 'Support',
                label: 'サポート',
            },
        ],
        productItems: [
            {
                href: '/jp/delta-2-max-portable-power-station',
                label: productMsg?.name,
                value: 'delta2max',
            },
        ],
        buyItems: [
            {
                value: '今すぐ購入',
                label: '今すぐ購入',
                href: productMsg?.buyLink || '',
            },
        ],
    };
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 时间线
    const crowdfundingTimeline = {
        stage1: crowdfundingTimeStamp,
        stage2: crowdfundingTimeStamp2,
        end: detailTimeStamp,
    };
    // 计时器
    const timer: any = useRef(null);
    const [stage, setStage] = useState(() => {
        // a=>flag1 预热 b=>flag2 详情 test 早鸟
        if (flag2 || (serverTimeStamp?.current >= detailTimeStamp && detailTimeStamp !== 0)) {
            return STAGES?.DETAIL;
        }
        if ((flag3 && serverTimeStamp?.current < detailTimeStamp) || (serverTimeStamp?.current >= crowdfundingTimeStamp && crowdfundingTimeStamp !== 0)) {
            return STAGES?.CROWDFUNDING;
        }
        if (flag1 || (serverTimeStamp?.current >= teaserTimeStamp && teaserTimeStamp !== 0)) {
            return STAGES?.TEASER;
        }
        return STAGES?.UNKNOWN;
    });

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
        setShowTab(val);
    };

    function handleTabChange(tab: { label: string; value: string }) {
        console.log(tab);
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${tab.value}`)?.classList.add('show-tab');
        setShowTab(tab.value);
    }

    useEffect(() => {
        if (!WHITE_SITE.includes(locale)) {
            router.push('/404');
        }
        // 测试环境异常
        if (serverTimeStamp?.current < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);

                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                } catch (e) {
                    console.log(e);
                }
            })();
        }
        // 倒计时结束完成之前一直执行定时器任务
        if (
            (serverTimeStamp.current < detailTimeStamp + 1000 && detailTimeStamp !== 0) ||
            (serverTimeStamp.current < crowdfundingTimeStamp && crowdfundingTimeStamp !== 0)
        ) {
            timer.current = setInterval(() => {
                // 详情 flag2
                serverTimeStamp.current += 1000;
                if (flag2 || (serverTimeStamp.current >= detailTimeStamp && detailTimeStamp !== 0)) {
                    clearInterval(timer.current);
                    return stage !== STAGES.DETAIL && setStage(STAGES.DETAIL);
                }
                // 早鸟 cid = test
                if (
                    (flag3 && serverTimeStamp?.current < detailTimeStamp) ||
                    (serverTimeStamp.current >= crowdfundingTimeStamp && crowdfundingTimeStamp !== 0)
                ) {
                    if (detailTimeStamp === 0) {
                        clearInterval(timer.current);
                    }
                    return stage !== STAGES.CROWDFUNDING && setStage(STAGES.CROWDFUNDING);
                }
                // 预热 flag1
                if (flag1 || (serverTimeStamp.current >= teaserTimeStamp && teaserTimeStamp !== 0)) {
                    return stage !== STAGES.TEASER && setStage(STAGES.TEASER);
                }
                stage !== STAGES.UNKNOWN && setStage(STAGES.UNKNOWN);
                // setStage(STAGES.TEASER)
                return router.push('/404');
            }, 1000);
        } else {
            clearInterval(timer.current);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    useEffect(() => {
        // 日本预热 和 早鸟/详情的SEO信息不一样
        if (locale === 'jp' && stage === STAGES.TEASER) {
            setSeoInfo({ title: t('teaser.seo_title'), desc: t('teaser.seo_desc') });
        }
    }, [stage, locale, t]);

    return (
        <>
            <SEO title={seoInfo.title || t('seo_title')} description={seoInfo.desc || t('seo_desc')} />
            <SEOlinksA list={WHITE_SITE} locale={locale} pathname={productMsg.url} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                {locale === 'jp' ? (
                    <EcoNavProduct {...dataA} onTabChange={handleTabChange} />
                ) : (
                    <ProductNav
                        className="wbg"
                        title={productMsg?.name}
                        theme={'white'}
                        buyLink={productMsg?.buyLink || ''}
                        callback={tabState}
                        productKey={productName}
                    />
                )}
                <div className="product-tab product-tab-Overview show-tab">
                    {showTab === 'Overview' && (
                        <>
                            <PageCon
                                stage={Number(query?.debug) || stage}
                                productDetail={productDetail}
                                resProductCatagory={resProductCatagory}
                                supportData={supportData}
                                crowdfundingTimeline={crowdfundingTimeline}
                                nowSysTime={serverTimeStamp?.current}
                            />
                            {locale !== 'jp' && (
                                <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={isMobile ? {} : { width: '1120px' }} />
                            )}
                        </>
                    )}
                </div>
                <div className="product-tab product-tab-Specs">
                    {showTab === 'Specs' && <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />}
                </div>
                <div className="product-tab product-tab-Support">
                    {showTab === 'Support' && <ProductSupport theme={theme} supportData={supportData}></ProductSupport>}
                </div>
            </PageLayout>
            <style jsx global>
                {`
                    .product_naver {
                        display: ${!['eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'ph', 'nl'].includes(locale) && stage !== STAGES.DETAIL ? 'none' : 'block'};
                    }
                    .product_naver .right a {
                        display: ${['eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'ph', 'nl'].includes(locale) && stage === STAGES.TEASER
                            ? 'none'
                            : 'inline-block'};
                    }
                    .product_naver .right .btn-link {
                        display: ${['eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'ph', 'nl'].includes(locale) && stage === STAGES.TEASER
                            ? 'none'
                            : 'inline-block'};
                    }
                `}
            </style>
        </>
    );
}
